<script>
	import { navigate } from "svelte-routing";
	import CustomTable from "../../../../components/CustomTable/CustomTable.svelte";

	export let data = [];
	export let changeFetchParams;

	function navigateToDetails(vehicleId) {
		navigate(`/issues/case-management/quotation/${vehicleId}`);
	}

	// handle parent sort event
	function handleSort({ detail: { column, direction } }) {
		changeFetchParams({ sortCol: column, sortDir: direction });
	}
</script>

<CustomTable
	columns={[
		{ key: "caseNo", label: "Case No." },
		{
			label: "Case Created",
			key: "createdAt",
			type: "date",
			sortCol: "caseCreatedAt",
		},
		{
			label: "Vehicle No",
			key: "plateNo",
			type: "link",
			linkBy: "vehicleId",
			linkTo: "/car-management/details/",
		},
		{ label: "Asset Owner", key: "carAssetOwners", type: "masterdata" },
		{ label: "Investigator", key: "investigator" },
		{ label: "Last Updated", key: "updatedAt", type: "date" },
		{ key: "caseOrigin", label: "Case Origin", type: "masterdata" },
		{
			key: "actions",
			label: "Actions",
			type: "actions",
			event: navigateToDetails,
			action: "edit",
		},
	]}
	rows={data}
	emptyMessage="There are currently no cases to display."
	on:sort={handleSort}
/>
